




import { Vue, Component } from 'vue-property-decorator';
import { orderListTypes, focusTabName } from '@/const/order';
import ContentBottom from '@/components/shipping/order/ContentBottom.vue';

@Component({
  components: {
    ContentBottom,
  },
})
export default class OrderPayFail extends Vue {
  private orderListTypes = orderListTypes.PAY_FAIL;
  private orderSearchTypes = focusTabName.ORDER_TAB;
}
